(function () {
  const DESKTOP_QUERY = '(min-width: 1150px)';

  const isDesktop = () => window.matchMedia(DESKTOP_QUERY).matches;

  const applyFooterState = (footerDetails) => {
    // Desktop: keep everything open (looks like normal footer menus)
    if (isDesktop()) {
      footerDetails.forEach((d) => d.setAttribute('open', ''));
      return;
    }
    // Mobile/Tablet: start closed
    footerDetails.forEach((d) => d.removeAttribute('open'));
  };

  const footer = () => {
    const footerDetails = document.querySelectorAll('.footer .accordion details');
    if (!footerDetails.length) return;

    // 1) Initial state depending on viewport
    applyFooterState(footerDetails);

    // 2) Mobile behaviour: only one open at a time
    footerDetails.forEach((detail) => {
      // prevent double binding in theme editor
      if (detail.dataset.bound === 'true') return;
      detail.dataset.bound = 'true';

      detail.addEventListener('toggle', () => {
        // On desktop we keep all open — do nothing
        if (isDesktop()) return;

        // If this one just opened, close the others
        if (detail.open) {
          footerDetails.forEach((other) => {
            if (other !== detail) other.removeAttribute('open');
          });
        }
      });
    });

    // 3) On resize: re-apply state (debounced)
    let t = null;
    window.addEventListener('resize', () => {
      clearTimeout(t);
      t = setTimeout(() => applyFooterState(footerDetails), 150);
    });
  };

  document.addEventListener('shopify:section:load', footer);
  footer();
})();
